import React, { useState } from 'react';
import Favourite from '../Favourite';
import useCard from './useCard';

const Card = ({ payload, type, className = '' }) => {
  const {
    id,
    title,
    image,
    url,
    details,
    excerpt,
    price,
    destinations,
    visibleDestinations,
    subtitle,
    collections,
    travel_type: travelType,
    holidayStyles,
    class: shipClass,
    capacity,
  } = payload;
  const { getDestinationsString } = useCard();

  const [tooltipOpen, setTooltipOpen] = useState(false);

  const getClassName = (type) => {
    const typeMap = {
      holiday: 'holiday',
      accommodation: 'accommodation',
      ship: 'ship',
    };

    return typeMap[type] || 'thing_to_do';
  };

  const getContent = (type) => {
    switch (type) {
      case 'holiday':
        return (
          <>
            <a
              href={url}
              className="o-card__content__tag"
              dangerouslySetInnerHTML={{
                __html: getDestinationsString(visibleDestinations) || '',
              }}
            ></a>

            <a href={url} className="o-card__content__title">
              <span
                className="u-weight--medium"
                dangerouslySetInnerHTML={{ __html: title.display }}
              ></span>
              <br />
              {subtitle}
            </a>

            <div className="o-card__content__text">
              <a href={url} className="o-text o-text--heavy u-mb-0">
                {details.display}{' '}
                {price.slug !== '' && (
                  <>
                    from{' '}
                    <span className="u-color--purple u-weight--bold">
                      {price.display}
                    </span>
                  </>
                )}
              </a>

              {price.slug !== '' && (
                <div className="o-tooltip o-tooltip--inline u-ml-3">
                  <a
                    className="o-tooltip__link"
                    onClick={() => setTooltipOpen(true)}
                  >
                    <svg className="o-tooltip__link__icon" role="presentation">
                      <use xlinkHref="/assets/icons/icons.svg#sprite-question"></use>
                    </svg>
                  </a>

                  {/* popup */}
                  <div
                    className={`o-tooltip__content ${
                      tooltipOpen ? 'o-tooltip__content--visible' : ''
                    }`}
                  >
                    <p className="o-text o-text--large u-color--green u-weight--bold u-mb-1">
                      {details.display}{' '}
                      {price.slug !== '' && (
                        <>
                          from{' '}
                          <span className="u-weight--bold">
                            {price.display}
                          </span>
                        </>
                      )}
                    </p>

                    <p className="o-text o-text--heavy">
                      (based on two people sharing & excluding flights)
                    </p>

                    <p className="o-text">
                      The holiday price excludes international flights. We are
                      happy to quote flights separately based on your dates of
                      travel and preferences.
                    </p>

                    <a href="/contact" className="o-btn o-btn--full">
                      Contact us
                    </a>

                    <a
                      className="o-tooltip__content__close"
                      onClick={() => setTooltipOpen(false)}
                    ></a>

                    <svg
                      className="o-tooltip__content__icon"
                      role="presentation"
                    >
                      <use xlinkHref="/assets/icons/icons.svg#sprite-question"></use>
                    </svg>
                  </div>
                </div>
              )}
            </div>
          </>
        );
      case 'accommodation':
        return (
          <>
            <a
              className="o-card__content__tag"
              href={url}
              dangerouslySetInnerHTML={{
                __html:
                  destinations && destinations.length > 1
                    ? destinations[0].display
                    : '',
              }}
            ></a>
            <a
              href={url}
              className="o-card__content__title"
              dangerouslySetInnerHTML={{ __html: title.display }}
            ></a>

            {shipClass && (
              <p className="c-listing__class" hidden>
                <strong>Class:</strong> {shipClass}
              </p>
            )}

            {price && (
              <p className="c-listing__price-range" hidden>
                <strong>Price bracket:</strong> {price}
              </p>
            )}

            {capacity && (
              <p className="c-listing__capacity" hidden>
                <strong>Capacity:</strong> {capacity}
              </p>
            )}

            {excerpt && shipClass && (
              <p className="c-listing__excerpt" hidden>
                {excerpt}
              </p>
            )}
          </>
        );
      default:
        return (
          <a
            href={url}
            className="o-card__content__title"
            dangerouslySetInnerHTML={{ __html: title.display }}
          ></a>
        );
    }
  };

  const getAdditionalLabel = (type) => {
    switch (type) {
      case 'holiday':
        return holidayStyles && holidayStyles.length > 0 ? (
          <span
            className="o-card__img__overlay__label"
            dangerouslySetInnerHTML={{
              __html: holidayStyles.reduce((total, current, index) => {
                return `${total} ${current.display} ${
                  index + 1 < holidayStyles.length ? ' | ' : ''
                }`;
              }, ''),
            }}
          ></span>
        ) : null;
      // return holidayStyles.length > 0 ? (
      //   <span className="o-card__img__overlay__label">
      //     {holidayStyles.map((style) => (
      //       <span key={`holiday--${id}--style--${style.id}`}>
      //         {style.display}
      //       </span>
      //     ))}
      //   </span>
      // ) : null;
      default:
        return null;
    }
  };

  const getTopOverlay = (travelType, collections) => {
    return (
      <>
        {travelType && (
          <div
            className="o-card__img__top-overlay__type"
            dangerouslySetInnerHTML={{ __html: travelType.display }}
          ></div>
        )}
        {collections && collections.length > 0 ? (
          <div className="o-card__img__top-overlay__collections">
            {collections.map((collection) => (
              <div
                className="o-card__img__top-overlay__collections__collection u-weight--semibold"
                key={`holiday--${id}--collection--${collection.id}`}
              >
                {collection.display}
              </div>
            ))}
          </div>
        ) : null}
      </>
    );
  };

  return (
    <div
      className={`o-card o-card--${getClassName(type)} ${className} test ${
        travelType?.slug
      }`}
    >
      <div className="o-card__img">
        <a href={url} className="o-card__img__wrap">
          <img
            src={image}
            alt=""
            className="u-object-fit lazyload"
            lazy="true"
          />
        </a>

        {type === 'holiday' && travelType?.slug && (
          <div className="o-card__img__top-overlay">
            {getTopOverlay(travelType, collections)}
          </div>
        )}

        <div className="o-card__img__overlay">
          {getAdditionalLabel(type)}

          <Favourite id={id} type={type} white />
        </div>
      </div>

      <div className="o-card__content">{getContent(type)}</div>
    </div>
  );
};

export default Card;
